application.register("layout_footer", class extends Stimulus.Controller {
    setHover() {
        this.element._addDataValue('state','hover')
    }

    unsetHover() {
        this.element._removeDataValue('state','hover')
    }
});
